import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import Portal from '../../../components/Portal';
import QuestionnaireTable from '../components/QuestionnaireTable';
import QuestionnaireTabs from '../components/QuestionnaireTabs';

const QuestionnaireList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">My Questionnaire</span>
      </Portal>
      {pageSize && (
        <QuestionnaireTabs>
          <QuestionnaireTable />
        </QuestionnaireTabs>
      )}
    </Card>
  );
};

export default QuestionnaireList;
